module.exports = __webpack_public_path__ + "static/bsas017.thumb-54f0733f5455043a042233316970e30b.jpg";